import GeoData from './geoData.js';
import {norm2DVect} from '../utils/utils.js';
import {ScalarData, scalarDataFromJson} from './scalarData.js';

export class VectorData extends GeoData {
  constructor(size) {
    super(size);

    this.data = math.zeros([size[0],size[1],3]);//new Array(size[0]).fill(new Array(size[1]).fill(new Array(3).fill(0)));
  }

  setData(data) {
    if (data.length == this.size[0] && data[0].length == this.size[1]){
      this.min = [Infinity,Infinity,Infinity];
      this.max = [-Infinity,-Infinity,-Infinity];

      this.data = math.zeros([this.size[0],this.size[1],3]);
      for (var ith=0;ith<this.size[0];ith++) {
        for (var iph=0;iph<this.size[1];iph++) {
          var sourcepointdata = data[ith][iph];
          var destpointdata = this.data[ith][iph];
          //Converts Utheta Uphi from km/yr to degree/yr
          destpointdata[0] = sourcepointdata[0] / earthcorevisu.R_OUTER_CORE * 180 / Math.PI ;
          destpointdata[1] = sourcepointdata[1] /
                                    (earthcorevisu.R_OUTER_CORE * Math.sin(this.indexToθ(ith) * Math.PI / 180)) *
                                    180 / Math.PI ;

          if (sourcepointdata.length == 3) {
            destpointdata[2] = sourcepointdata[2];
          } else {
            destpointdata[2] = norm2DVect([sourcepointdata[0],sourcepointdata[1]]);
          }

          this.min[0] = Math.min(this.min[0],sourcepointdata[0]);
          this.max[0] = Math.max(this.max[0],sourcepointdata[0]);
          this.min[1] = Math.min(this.min[1],sourcepointdata[1]);
          this.max[1] = Math.max(this.max[1],sourcepointdata[1]);
          this.min[2] = Math.min(this.min[2],destpointdata[2]);
          this.max[2] = Math.max(this.max[2],destpointdata[2]);

        }
      }
      this.magmin = this.min[2];
      this.magmax = this.max[2];
    }
    else {
      throw "ERROR: data size must be " + this.size;
    }
  }

  /**
  * @return {Value} magnitude interpolation at θ,φ (spherical coordinates)
  *
  */
  interpolateValue(θφ,index=2) {
    if (!θφ) {
      return null;
    }
    let interpPoints = this.getInterpolationPoints(θφ);
    if (!interpPoints) {
      return null;
    }
    let [flooriθ,ceiliθ,flooriφ,ceiliφ,Δθ,Δφ,rθ,rφ] = interpPoints;
    let interp = this.data[flooriθ][flooriφ][index] * rθ * rφ + this.data[ceiliθ][flooriφ][index] * Δθ * rφ +
            this.data[flooriθ][ceiliφ][index] * rθ * Δφ + this.data[ceiliθ][ceiliφ][index] * Δθ * Δφ;

    if (index == 2) {
      return interp;
    }
    if (index == 1) {
      return interp * (earthcorevisu.R_OUTER_CORE * Math.sin(θφ[0] * Math.PI / 180)) / 180 * Math.PI;
    }
    if (index == 0) {
      return interp * earthcorevisu.R_OUTER_CORE / 180 * Math.PI ;
    }

  }

  /**
  * @return {Value} vector interpolation at θ,φ (spherical coordinates)
  *
  */
  interpolateVector(θφ) {
    if (!θφ) {
      return null;
    }
    let interpPoints = this.getInterpolationPoints(θφ);
    if (!interpPoints) {
      return null;
    }
    let [flooriθ,ceiliθ,flooriφ,ceiliφ,Δθ,Δφ,rθ,rφ] = interpPoints;
    if (this.data[flooriθ] === undefined || this.data[ceiliθ] === undefined ||
        this.data[flooriθ][flooriφ] === undefined || this.data[ceiliθ][flooriφ] === undefined ||
        this.data[flooriθ][ceiliφ] === undefined || this.data[ceiliθ][ceiliφ] === undefined) {
      return null;
    }
    return [this.data[flooriθ][flooriφ][0] * rθ * rφ + this.data[ceiliθ][flooriφ][0] * Δθ * rφ +
            this.data[flooriθ][ceiliφ][0] * rθ * Δφ + this.data[ceiliθ][ceiliφ][0] * Δθ * Δφ ,
      this.data[flooriθ][flooriφ][1] * rθ * rφ + this.data[ceiliθ][flooriφ][1] * Δθ * rφ +
            this.data[flooriθ][ceiliφ][1] * rθ * Δφ + this.data[ceiliθ][ceiliφ][1] * Δθ * Δφ ,
      this.data[flooriθ][flooriφ][2] * rθ * rφ + this.data[ceiliθ][flooriφ][2] * Δθ * rφ +
            this.data[flooriθ][ceiliφ][2] * rθ * Δφ + this.data[ceiliθ][ceiliφ][2] * Δθ * Δφ];
  }

  getValue(θφ,index=2) {
    if (!θφ) {
      return null;
    }
    let closestPoint = this.getClosestPoint(θφ);
    if (!closestPoint) {
      return null;
    }
    if (index == 2) {
      return this.data[closestPoint[0]][closestPoint[1]][index];
    }
    if (index == 1) {
      return this.data[closestPoint[0]][closestPoint[1]][index] *
                               (earthcorevisu.R_OUTER_CORE * Math.sin(θφ[0] * Math.PI / 180)) / 180 * Math.PI;
    }
    if (index == 0) {
      return this.data[closestPoint[0]][closestPoint[1]][index]  * earthcorevisu.R_OUTER_CORE / 180 * Math.PI ;
    }

  }

  getVector(θφ) {
    if (!θφ) {
      return null;
    }
    let closestPoint = this.getClosestPoint(θφ);
    if (!closestPoint) {
      return null;
    }
    return this.data[closestPoint[0]][closestPoint[1]];
  }
}

export function vectorDataFromJson(json) {
  var ntheta = json.dataarray.length;
  var nphi = json.dataarray[0].length;
  var data = new VectorData([ntheta,nphi]);
  data.stepθ = json.theta_step;
  data.stepφ = json.phi_step;
  data.setData(json.dataarray);
  return data;
}

export function scalarDataFromVectorJson(json,dataIndex) {
  var ntheta = json.dataarray.length;
  var nphi = json.dataarray[0].length;
  var data = new ScalarData([ntheta,nphi]);
  data.stepθ = json.theta_step;
  data.stepφ = json.phi_step;

  var dataarray = math.zeros([ntheta,nphi]);
  for (var ith=0;ith<ntheta;ith++) {
    for (var iph=0;iph<nphi;iph++) {
      if (dataIndex == 2 && json.dataarray[ith][iph].length < 3) {
        dataarray[ith][iph] = norm2DVect([json.dataarray[ith][iph][0],json.dataarray[ith][iph][1]]);
      } else {
        dataarray[ith][iph] = json.dataarray[ith][iph][dataIndex];
      }
    }
  }
  data.setData(dataarray);
  return data;
}



//////////////////
// WEBPACK FOOTER
// ./src/model/vectorData.js
// module id = 26
// module chunks = 0